import Subscribe from "../components/Subscribe";
import translations from "../translations/french.json";
import { Grid } from "@mui/material";
import Wrapper from "../components/Wrapper";

const SubscribeFr = () => {
  return (
    <div>
      <Wrapper lang="fr">
        <Grid container alignItems="center" justifyContent="center">
          <Subscribe translations={translations.subscribe} lang="fr" />
        </Grid>
      </Wrapper>
    </div>
  );
};

export default SubscribeFr;
